var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadSm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.969,
    height: 15.933,
    viewBox: "0 0 12.969 15.933",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_49610",
    "data-name": "Path 49610",
    d: "M6.684,1.847a2.025,2.025,0,0,1,1.441-.6h6.056a2.04,2.04,0,0,1,2.038,2.038V15.145a2.04,2.04,0,0,1-2.038,2.038H5.288A2.04,2.04,0,0,1,3.25,15.145V6.125a2.025,2.025,0,0,1,.6-1.441L6.684,1.847Zm.434,9.2a.556.556,0,0,0,0,.786l2.223,2.223a.556.556,0,0,0,.786,0l2.223-2.223a.556.556,0,1,0-.786-.786L10.29,12.321v-3.1a.556.556,0,0,0-1.112,0v3.1L7.9,11.047a.556.556,0,0,0-.786,0Z",
    transform: "translate(-3.25 -1.25)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadSm);
export default __webpack_public_path__ + "static/media/downloadSm.955a3209f4af46d5245fe9e983bdddde.svg";
export { ForwardRef as ReactComponent };